import styled from 'styled-components';
export const ParamDescriptorWrapper = styled.div.withConfig({
  displayName: "Helpers__ParamDescriptorWrapper",
  componentId: "sc-1rm42gs-0"
})(["width:136px;"]);